export default __webpack_public_path__ + "static/media/s_gts1.d9593237.jpg";